import { render, staticRenderFns } from "./disputes-dialog-task-form.vue?vue&type=template&id=73851c40&scoped=true"
import script from "./disputes-dialog-task-form.vue?vue&type=script&lang=js"
export * from "./disputes-dialog-task-form.vue?vue&type=script&lang=js"
import style0 from "./disputes-dialog-task-form.vue?vue&type=style&index=0&id=73851c40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73851c40",
  null
  
)

export default component.exports